/* eslint-disable jsx-a11y/img-redundant-alt */
import { Container } from 'react-bootstrap';
import { Switch } from 'react-router';
import ProtectedRoute from './ProtectedRoute';
import { summerProgramsRoutes } from './router';
import Header from 'components/layout/header';
import MobileHeader from 'components/layout/MobileHeader';
import SideBar from 'components/layout/sideBar';
import UnifiedChatList from 'components/layout/UnifiedChatList';
import { useAppSelector } from 'app/hooks';
// import { useCounselor } from 'hooks/useCounselor';

const SummerProgramsLayout = () => {
  const information = useAppSelector((store) => store.basicInformation.myBasicInformation);
  const role  = information?.user_role ?? '';
  sessionStorage.setItem('userRole', role);

  const sidebarCollapsed = useAppSelector((store) => store.appStore.sidebarCollapsed);
  const sidebarWidth = sidebarCollapsed ? '130px' : '290px'; // 70px toolbar + 60px mini menu when collapsed
  // const basicInformation = useAppSelector((store) => store.basicInformation.myBasicInformation);
  // const { counselor, loading: counselorLoading } = useCounselor();
  
  return (
    <Container fluid className="vh-100 overflow-hidden px-0" style={{ position: 'relative' }}>
        <div className="d-none d-sm-block w-100" style={{ minHeight: '58px' }}>
          <Header title="Summer Programs" />
        </div>
        <div className="d-block d-sm-none w-100">
          <MobileHeader />
        </div>
        <div className="gm-content">
          <div className="d-none d-sm-block border-end" style={{ width: sidebarWidth, height: '100%' }}>
            <SideBar />
          </div>
          <div className="h-100 overflow-auto pb-5 content-styled">
            <Switch>
              {Object.keys(summerProgramsRoutes).map((route, index) => (
                <ProtectedRoute
                  key={index}
                  path={summerProgramsRoutes[route].path}
                  component={summerProgramsRoutes[route].component}
                  exact
                />
              ))}
            </Switch>
          </div>
        </div>

        {/* Unified Chat List - Show for all roles when toggled */}
        <UnifiedChatList />
        
        <style>{`
        .content-styled {
          width: calc(100vw - ${sidebarWidth});
        }
        @media screen and (max-width: 600px) {
          .content-styled {
            width: 100vw !important;
          }
        }
        `}</style>
      </Container>
  );
};

export default SummerProgramsLayout;

